import * as yup from 'yup';

export const rejectOTByTecnicoSchema = yup.object({
  motivo_rechazo: yup.string().required('El campo motivo rechazo es requerido'),
  observacion_actualizacion_tecnico: yup
    .string()
    .required('El campo observacion rechazo tecnico es requerido')
    .min(
      10,
      'El campo observacion rechazo tecnico debe tener al menos 10 caracteres'
    )
    .max(
      200,
      'El campo observacion rechazo tecnico no debe exceder los 200 caracteres'
    ),
  estado_orden_trabajo: yup
    .string()
    .required('El campo estado orden trabajo es requerido'),
});

export const rejectOTInstalacionByTecnicoSchema = yup.object({
  motivo_rechazo: yup.string().required('El campo motivo rechazo es requerido'),
  observacion_rechazo_tecnico: yup
    .string()
    .required('El campo observacion rechazo tecnico es requerido')
    .min(
      10,
      'El campo observacion rechazo tecnico debe tener al menos 10 caracteres'
    )
    .max(
      200,
      'El campo observacion rechazo tecnico no debe exceder los 200 caracteres'
    ),
  estado_orden_trabajo: yup
    .string()
    .required('El campo estado orden trabajo es requerido'),
});

export const reportarNovedadOTSchema = yup.object({
  estado_informe: yup.string().required('El campo estado es requerido'),
  categoria_rechazo: yup
    .string()
    .required('El campo categoría es requerido'),
  motivo_rechazo: yup
    .string()
    .required('El campo subcategoría es requerido'),
  observacion_rechazo_tecnico: yup
    .string()
    .required('El campo observación rechazo es requerido')
    .min(
      10,
      'El campo observación rechazo debe tener al menos 10 caracteres'
    )
    .max(
      200,
      'El campo observación rechazo no debe exceder los 200 caracteres'
    ),
  estado_orden_trabajo: yup
    .string()
    .required('El campo estado orden trabajo es requerido'),
});
